import React from 'react';
import PropTypes from 'prop-types';
import {IconButton, makeStyles, Snackbar, Box} from '@material-ui/core';
import {CheckCircle, Cancel, Error, Info} from '@material-ui/icons';

const useStyles = makeStyles(({palette}) => ({
  icon: {
    color: palette.common.white
  },
  snackbar: {
    borderRadius: 10
  },
  success: {
    backgroundColor: palette.success.main
  },
  error: {
    backgroundColor: palette.error.main
  },
  warning: {
    backgroundColor: palette.warning.main
  },
  info: {
    backgroundColor: palette.info.main
  }
}));

const icon = {
  success: <CheckCircle />,
  error: <Cancel />,
  warning: <Error />,
  info: <Info />
};

const SnackbarMui = ({open, onClose, type, message, duration}) => {
  const styles = useStyles();

  return (
    <Snackbar
      open={open}
      onClose={onClose}
      message={
        <Box display="flex" flexDirection="row" alignItems="center" justifyContent="center">
          <IconButton className={styles.icon}>{icon[type]}</IconButton>
          <Box>
            {message?.includes('\n')
              ? message?.split('\n').map((line) => <Box key={line}>{line}</Box>)
              : message}
          </Box>
        </Box>
      }
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center'
      }}
      autoHideDuration={duration}
      className={`${styles.snackbar} ${styles[type]}`}
    />
  );
};

SnackbarMui.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  type: PropTypes.oneOf(['success', 'error', 'warning', 'info']),
  message: PropTypes.any,
  duration: PropTypes.number
};

SnackbarMui.defaultProps = {
  open: false,
  type: 'success',
  duration: 6000
};

export default SnackbarMui;
